import { render, staticRenderFns } from "./ProdEditAppr.vue?vue&type=template&id=727e767b&scoped=true&"
import script from "./ProdEditAppr.vue?vue&type=script&lang=js&"
export * from "./ProdEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727e767b",
  null
  
)

export default component.exports